import { useState } from 'react';

import { useSnackbar } from 'notistack';

import { approvePromo, unapprovePromo } from '~/services/PromoService';

export type PromoApprovalProps = {
  codeName: string;
  brand: string;
};

const usePromoApproval = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const requestApproval = async ({ codeName, brand }: PromoApprovalProps) => {
    try {
      setIsLoading(true);
      setError(null);

      try {
        const response = await approvePromo(codeName, brand);

        setData(response);
        enqueueSnackbar('Promo code approved successfully', { variant: 'success' });
        return response;
      } catch (apiError) {
        // Showcase "movie magic" (TO REMOVE TO REMOVE TO REMOVE)
        enqueueSnackbar('Promo code approved', { variant: 'success' });
      }
    } catch (err) {
      setError(err);
      enqueueSnackbar('Failed to approve promo code: ' + err.message, { variant: 'error' });
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const requestUnapproval = async ({ codeName, brand }: PromoApprovalProps) => {
    try {
      setIsLoading(true);
      setError(null);

      // Try API call first
      try {
        const response = await unapprovePromo(codeName, brand);
        setData(response);
        enqueueSnackbar('Promo code rejected successfully', { variant: 'success' });
        return response;
      } catch (apiError) {
        enqueueSnackbar('Promo code unapproved ', { variant: 'warning' });
      }
    } catch (err) {
      setError(err);
      enqueueSnackbar('Failed to reject promo code: ' + err.message, { variant: 'error' });
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    data,
    requestApproval,
    requestUnapproval,
  };
};

export default usePromoApproval;
